import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "FinanceReport" })((theme) => ({
  page: {
    margin: "20px",
  },
}));
